import React from 'react';
import { DynamicFormHeaderProps } from './types';

/**
 * Dynamic form header component for displaying titles and descriptions
 * 
 * @param header - Header configuration object containing label and optional description
 * @returns JSX element for the header display
 */
const DynamicFormHeader: React.FC<DynamicFormHeaderProps> = (header) => {
  return (
    <div className="flex flex-col gap-2">
      <h2 className="text-xl font-semibold text-primary">{header.label}</h2>
      {header.description && <p className="text-sm text-quaternary">{header.description}</p>}
    </div>
  );
};

export default DynamicFormHeader;